import { isObject } from './type'

/**
 * Generates a UUID.
 *
 * See {@link https://gist.github.com/LeverOne/1308368}.
 */
export function generateUUID (): string {
  let a = 0
  let b = ''
  for (; a++ < 36;) {
    b += a * 51 & 52 ? (a ^ 15 ? 8 ^ Math.random() * (a ^ 20 ? 16 : 4) : 4).toString(16) : '-'
  }
  return b
}

/**
 * Regex to validate a UUID that has been generated by {@link generateUUID}.
 */
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/

/**
 * Assign UUID to all objects with a "uuid4" field recursively, using {@link generateUUID}.
 */
export function addUUIDs<T extends object> (value: T): T {
  if ('uuid4' in value && !value.uuid4) {
    value.uuid4 = generateUUID()
  }
  for (const v of Object.values(value)) {
    if (Array.isArray(v)) {
      for (const item of v) {
        if (isObject(item)) addUUIDs(item)
      }
    } else if (isObject(v)) {
      addUUIDs(v)
    }
  }
  return value
}
